
(function () {
  function goldenHomeFinalCleanFix() {
    var header = document.getElementById("goldenHomeFileHero");

    if (header) {
      var logo = header.querySelector(".ghFileLogo");
      if (logo) {
        logo.querySelectorAll("img").forEach(function (img, index) {
          var src = img.getAttribute("src") || "";
          if (index > 0 || /clean/i.test(src)) {
            img.style.display = "none";
            img.style.visibility = "hidden";
            img.style.opacity = "0";
            img.style.width = "0";
            img.style.height = "0";
          }
        });
      }
    }

    var root = document.getElementById("goldenHomeTrendingTabs");
    if (!root) return;

    root.querySelectorAll("*").forEach(function (el) {
      var text = (el.textContent || "").trim().toUpperCase();
      if ((text === "TRENDING" || text === "NEW ARRIVAL") && !el.querySelector("img") && el.children.length <= 1) {
        el.style.display = "none";
        el.style.visibility = "hidden";
        el.style.height = "0";
        el.style.minHeight = "0";
        el.style.maxHeight = "0";
        el.style.margin = "0";
        el.style.padding = "0";
        el.style.overflow = "hidden";
      }
    });

    root.querySelectorAll(".ghProductPrice").forEach(function (priceBox) {
      var main = priceBox.querySelector(".ghMainPrice");
      var currency = priceBox.querySelector(".ghMainPrice .ghPriceCurrency");
      var amount = priceBox.querySelector(".ghMainPrice .ghPriceAmount");
      var compare = priceBox.querySelector(".ghComparePrice");

      priceBox.style.background = "transparent";
      priceBox.style.border = "0";
      priceBox.style.padding = "0";
      priceBox.style.overflow = "visible";

      if (main) {
        main.style.background = "transparent";
        main.style.display = "grid";
        main.style.gridTemplateColumns = "auto minmax(0, 1fr)";
        main.style.alignItems = "center";
      }

      if (currency) {
        currency.style.background = "#000000";
        currency.style.color = "#ffffff";
        currency.style.justifySelf = "start";
      }

      if (amount) {
        amount.style.color = "#d60000";
        amount.style.textAlign = "right";
        amount.style.justifySelf = "end";
        amount.style.background = "transparent";
      }

      if (compare && !compare.classList.contains("isEmpty")) {
        compare.style.justifyContent = "flex-end";
        compare.style.textAlign = "right";
        compare.querySelectorAll(".ghPriceCurrency, .ghPriceAmount").forEach(function (item) {
          item.style.color = "#6b6b6b";
          item.style.textDecoration = "line-through";
          item.style.textAlign = "right";
        });
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", goldenHomeFinalCleanFix);
  } else {
    goldenHomeFinalCleanFix();
  }

  window.addEventListener("resize", goldenHomeFinalCleanFix);
  document.addEventListener("shopify:section:load", goldenHomeFinalCleanFix);
})();
